import React, { useState } from "react";
import LogoCEA from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import SyncLoader from "react-spinners/SyncLoader";
import DateInput from "./DateInput";

const RegisterOpenClass = ({ invitation = false }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [fullName, setFullName] = useState("");
  const [dob, setDob] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [classType, setClassType] = useState("");
  const [church, setChurch] = useState("");
  const [otherChurch, setOtherChurch] = useState("");
  const [city, setCity] = useState("");

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (
  //     !fullName ||
  //     !dob ||
  //     !phone ||
  //     !email ||
  //     !classType ||
  //     !church ||
  //     (church === "Others" && !otherChurch) ||
  //     !city
  //   ) {
  //     Swal.fire({ text: "Please fill all required fields.", icon: "warning", background: "white", color: "black", confirmButtonColor: "#fb3104" });
  //     return;
  //   }
  //   setIsLoading(true);
  //   try {
  //     await axios.post("/specialregistration", {
  //       type: "openclass",
  //       name: fullName,
  //       dateOfBirth: dob,
  //       email,
  //       phoneNumber: phone,
  //       classType,
  //       localChurch: church === "Others" ? otherChurch : church,
  //       city,
  //       isInvitation: invitation,
  //     });
  //     Swal.fire({
  //       title: "Registration Submitted!",
  //       text: "Thank you for registering. A confirmation email has been sent to your inbox.",
  //       icon: "success",
  //       background: "white",
  //       color: "black",
  //       confirmButtonColor: "#fb3104",
  //       confirmButtonText: "OK",
  //     }).then(() => navigate("/"));
  //   } catch (err) {
  //     Swal.fire({ text: err.response?.data?.msg || "Something went wrong.", icon: "error", background: "white", color: "black", confirmButtonColor: "#fb3104" });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (
    !fullName ||
    !dob ||
    !phone ||
    !email ||
    !classType ||
    !church ||
    (church === "Others" && !otherChurch) ||
    !city
  ) {
    Swal.fire({
      text: "Please fill all required fields.",
      icon: "warning",
      background: "white",
      color: "black",
      confirmButtonColor: "#fb3104",
    });
    return;
  }

  // Cegah salah ketik email: email & konfirmasinya harus sama.
  if (email.trim().toLowerCase() !== confirmEmail.trim().toLowerCase()) {
    Swal.fire({
      text: "Email and Confirm Email do not match. Please re-check your email address.",
      icon: "error",
      background: "white",
      color: "black",
      confirmButtonColor: "#fb3104",
    });
    return;
  }

  setIsLoading(true);

  try {
    await axios.post("/specialregistration", {
      type: "openclass",
      name: fullName,
      dateOfBirth: dob,
      email,
      phoneNumber: phone,
      classType,
      localChurch: church === "Others" ? otherChurch : church,
      city,
      isInvitation: invitation,
    });

    Swal.fire({
      title: "Registration Submitted!",
      text: "Thank you for registering. A confirmation email has been sent to your inbox.",
      icon: "success",
      background: "white",
      color: "black",
      confirmButtonColor: "#fb3104",
      confirmButtonText: "OK",
    }).then(() => {
      if (invitation === true) {
        window.location.reload();
      } else {
        navigate("/");
      }
    });
  } catch (err) {
    Swal.fire({
      text: err.response?.data?.msg || "Something went wrong.",
      icon: "error",
      background: "white",
      color: "black",
      confirmButtonColor: "#fb3104",
    });
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f4f4f4", display: "flex", justifyContent: "center", alignItems: "center", padding: "40px 16px" }}>
      {isLoading && (
        <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(255,255,255,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
          <SyncLoader color="#fb3104" />
        </div>
      )}
      <div style={{ backgroundColor: "#fff", borderRadius: "12px", padding: "40px", width: "100%", maxWidth: "520px", boxShadow: "0 4px 16px rgba(0,0,0,0.1)" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img src={LogoCEA} alt="CEA Logo" style={{ width: "64px", height: "64px", objectFit: "contain", marginBottom: "12px" }} />
          <h4 style={{ fontWeight: "700", color: "#fb3104", marginBottom: "4px" }}>
            {invitation ? "Open Class for Churches Registration" : "Open Class Registration"}
          </h4>
          <p style={{ color: "#666", fontSize: "14px", margin: 0 }}>Cutting Edge Academy</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Full Name <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="Your full name" />
          </div>
          <div className="mb-3">
            <label className="form-label">Date of Birth <span style={{ color: "#fb3104" }}>*</span></label>
            <DateInput className="form-control" value={dob} onChange={(e) => setDob(e.target.value)} />
          </div>
          <div className="mb-3">
            <label className="form-label">WhatsApp Number <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))} placeholder="628xxxxxxxxx" />
          </div>
          <div className="mb-3">
            <label className="form-label">Email <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@email.com" />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm Email <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="email" className="form-control" value={confirmEmail} onChange={(e) => setConfirmEmail(e.target.value)} onPaste={(e) => e.preventDefault()} placeholder="Re-type your email" />
            {confirmEmail !== "" && email.trim().toLowerCase() !== confirmEmail.trim().toLowerCase() && (
              <span style={{ color: "#dc2626", fontSize: "12px" }}>Email does not match</span>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Online / Onsite <span style={{ color: "#fb3104" }}>*</span></label>
            <div>
              <label style={{ marginRight: "20px" }}>
                <input
                  type="radio"
                  name="classType"
                  value="Onsite"
                  checked={classType === "Onsite"}
                  onChange={(e) => setClassType(e.target.value)}
                />
                &nbsp;Onsite
              </label>
              <label>
                <input
                  type="radio"
                  name="classType"
                  value="Online"
                  checked={classType === "Online"}
                  onChange={(e) => setClassType(e.target.value)}
                />
                &nbsp;Online
              </label>
            </div>
            <p style={{ fontSize: "12px", color: "#fb3104", marginTop: "6px", marginBottom: 0 }}>
              Perhatian: peserta tidak dapat berpindah dari Onsite ke Online maupun sebaliknya setelah mendaftar.
            </p>
          </div>

          <div className="mb-3">
            <label className="form-label">Church Name <span style={{ color: "#fb3104" }}>*</span></label>
            <select className="form-select" value={church} onChange={(e) => setChurch(e.target.value)}>
              <option value="">Select Church</option>
              <option value="IFGF Bandung">IFGF Bandung</option>
              <option value="Others">Others</option>
            </select>
          </div>
          {church === "Others" && (
            <div className="mb-3">
              <label className="form-label">Please specify your church <span style={{ color: "#fb3104" }}>*</span></label>
              <input type="text" className="form-control" value={otherChurch} onChange={(e) => setOtherChurch(e.target.value)} placeholder="Your church name" />
            </div>
          )}

          <div className="mb-4">
            <label className="form-label">Church City <span style={{ color: "#fb3104" }}>*</span></label>
            <input type="text" className="form-control" value={city} onChange={(e) => setCity(e.target.value)} placeholder="Your church's city" />
          </div>

          <button type="submit" style={{ width: "100%", padding: "10px", backgroundColor: "#fb3104", color: "#fff", border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "15px", cursor: "pointer" }}>
            Submit Registration
          </button>
          {!invitation && (
            <button type="button" onClick={() => navigate(-1)} style={{ width: "100%", marginTop: "10px", padding: "10px", backgroundColor: "transparent", color: "#888", border: "1px solid #ddd", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer" }}>
              Back
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default RegisterOpenClass;
